// Socket.io event names — must match server/ai/socket.js exactly.

export const CLIENT_EVENTS = {
  CHART_QUERY:  "ai:chart_query",
  USER_MESSAGE: "ai:user_message",
  CANCEL:       "ai:cancel",
};

export const SERVER_EVENTS = {
  THINKING_DELTA: "ai:thinking_delta",
  TEXT_DELTA:     "ai:text_delta",
  TOOL_CALL:      "ai:tool_call",
  CHART:          "ai:chart",
  CLARIFICATION:  "ai:clarification",
  PROGRESS_TEXT:  "ai:progress_text",
  // Structured per-tool progress (Sprint 6). Emitted by the ai-assistant loops' shareProgress
  // callback during tool execution (e.g. fetching_execution, resolving_template,
  // execution_assembled). The legacy /ai and /ai2 loops don't emit this.
  PROGRESS:       "ai:progress",
  // The agent committed to an interpretation via state_assumption (B-AMB-1). Emitted by the
  // ai-assistant Responses loop with { conversationId, assumption, rationale }. Rendered as a
  // distinct AssumptionBanner (Sprint 8a). Legacy /ai and /ai2 loops don't emit this.
  ASSUMPTION:     "ai:assumption",
  STAGE:          "ai:stage",
  DONE:           "ai:done",
  ERROR:          "ai:error",
};
